module.exports = __webpack_public_path__ + "static/media/watchlist-w.54841b1c.svg";